import React from 'react';
import { Column } from '@ant-design/plots';
import numeral from 'numeral';
import { useTranslation } from 'react-i18next';

import config from 'config/config';

import { TransformedRisk } from '../ByRisk.model';

type SeriesField = 'seriesField_1' | 'seriesField_2';
export interface DataRaw extends TransformedRisk {
  seriesField_1: number;
  seriesField_2: number;
}
export interface Data {
  xField: string;
  yField: number;
  seriesField: SeriesField;
  raw: DataRaw;
}
interface Props {
  data: Data[];
  currency: string;
}

const ByRiskChart = ({ data, currency }: Props) => {
  const { t } = useTranslation();

  return (
    <Column
      data={data}
      xField="xField"
      yField="yField"
      seriesField="seriesField"
      isGroup
      height={350}
      xAxis={{
        verticalLimitLength: 100,
        label: {
          autoRotate: true,
          autoEllipsis: true,
        },
      }}
      tooltip={{
        formatter: (datum: Pick<Data, 'xField' | 'yField' | 'seriesField'>) => {
          return {
            name:
              datum.seriesField === 'seriesField_1'
                ? t('dashboard_extend.byRisk.contractPaymentSum')
                : t('dashboard_extend.byRisk.claimPaymentSum'),
            value: `${numeral(datum.yField).format(config.format.financial)} ${currency}`,
          };
        },
      }}
      legend={{
        itemName: {
          formatter: (v: SeriesField) => {
            return v === 'seriesField_1'
              ? t('dashboard_extend.byRisk.contractPaymentSum')
              : t('dashboard_extend.byRisk.claimPaymentSum');
          },
        },
      }}
      color={['#c2db8a', '#95cff4']}
      columnStyle={{
        radius: [20, 20, 0, 0],
      }}
      state={{
        active: {
          style: {
            lineWidth: 'none',
          },
        },
      }}
    />
  );
};

const Memoized = React.memo(ByRiskChart);

export default Memoized;
